
export default function RegisterSection() {
 
 return (
      <section className="pb-16 bg-white min-h-screen">
        <div style={{ minHeight: '300px' }}>
          <div data-mariana-integrations="/account/create"></div>
        </div>
      </section>
  );
}
